module.exports = __webpack_public_path__ + "static/img/fa_data_3.02cb841.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/pc/fa/fa_data_3.jpg
// module id = 168
// module chunks = 0